const languageMenuReducer = (isOpen = false, action) => {
    switch(action.type) {
        case 'TOGGLE_LANGUAGEMENU':
            return action.payload;
        default:
            return isOpen;
    }
};

export default languageMenuReducer;